import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Table,
  Input,
  Button,
  Label,
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// Redux
import { useDispatch } from "react-redux";
import { getIncome } from "connection/backend";
import { get_file } from "connection/api";

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

const Income = () => {
  const dispatch = useDispatch();
  const URL = process.env.REACT_APP_URL;
  const [loading, setLoading] = useState(false);
  const [consignments, setConsignments] = useState([]);
  const [createdDateRange, setCreatedDateRange] = useState([]);
  const [bankFilter, setBankFilter] = useState("");
  const [payment_method, setPaymentMethod] = useState("");
  const [payment_type, setPaymentType] = useState("");
  const [search, setSearch] = useState("");
  const [bank, setBank] = useState(0);
  const [cash, setCash] = useState(0);
  const [total, setTotal] = useState(0);

  const onChange1 = (e) => {
    setSearch(e.target.value);
  };

  const onChange2 = (createdDateRange) => {
    setCreatedDateRange(createdDateRange);
  };

  const onChange3 = (e) => {
    setPaymentMethod(e.target.value);
  };

  const onChange4 = (e) => {
    setPaymentType(e.target.value);
  };

  const onChange5 = (e) => {
    setBankFilter(e.target.value);
  };

  const onClick = async () => {
    const date_1 = createdDateRange[0]
      ? createdDateRange[0].toISOString().slice(0, 10)
      : "";
    const date_2 = createdDateRange[1]
      ? createdDateRange[1].toISOString().slice(0, 10)
      : "";
    const excel_url = `${URL}report/ingresos_excel/?client_code=${search}&created_date_after=${date_1}&created_date_before=${date_2}&bank=${bankFilter}&payment_method=${payment_method}&payment_type=${payment_type}`;
    try {
      const response = await get_file(excel_url);
      const blob = new Blob([response.data], {
        type: "application/vnd.ms-excel",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = date_1 && date_2 ? `Ingresos_${date_1}_${date_2}.xlsx` : `Ingresos.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error("Error al descargar el archivo", error);
    }
  };

  const resetFilter = () => {
    setSearch("");
    setCreatedDateRange("");
    setConsignments([]);
    setTotal(0);
    setCash(0);
    setBank(0);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const date_1 = createdDateRange[0]
      ? createdDateRange[0].toISOString().slice(0, 10)
      : "";
    const date_2 = createdDateRange[1]
      ? createdDateRange[1].toISOString().slice(0, 10)
      : "";
    let url = `?client_code=${search}&created_date_after=${date_1}&created_date_before=${date_2}&bank=${bankFilter}&payment_method=${payment_method}&payment_type=${payment_type}`;
    getData(url);
  };

  const getData = async (url) => {
    setLoading(true);
    const response = await getIncome(url);
    setConsignments(response.data.consignments);
    setBank(response.data.bank);
    setCash(response.data.cash);
    setTotal(response.data.total);
    setLoading(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Reportes </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Reportes"} />
          {loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              <Card
                style={{
                  width: "90rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-0 font-size-20">Ingresos</h2>
                </CardTitle>
                <CardBody>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-start">
                      <Col lg={3}>
                        <p className="mb-1 font-size-13">Fecha:</p>
                        <InputGroup>
                          <Flatpickr
                            className="form-control"
                            placeholder="dd/mm/aaaa"
                            value={createdDateRange}
                            onChange={onChange2}
                            options={{
                              mode: "range",
                              dateFormat: "d/m/Y",
                              locale: Spanish,
                            }}
                          />
                        </InputGroup>
                      </Col>
                      <Col lg={2}>
                        <p className="mb-1 font-size-13">Banco:</p>
                        <Input
                          type="select"
                          className="form-select"
                          name="bankFilter"
                          value={bankFilter}
                          onChange={onChange5}
                        >
                          <option value="" defaultValue>
                            Todos
                          </option>
                          <option value="banco_1">Banco de Bogotá</option>
                          <option value="banco_2">Bancolombia</option>
                        </Input>
                      </Col>
                      <Col lg={2}>
                        <p className="mb-1 font-size-13">Medio de pago:</p>
                        <Input
                          type="select"
                          className="form-select"
                          name="payment_method"
                          value={payment_method}
                          onChange={onChange3}
                        >
                          <option value="" defaultValue>
                            Todos
                          </option>
                          <option value="efectivo">Efectivo</option>
                          <option value="consignacion">Consignación</option>
                          <option value="cheque">Cheque</option>
                        </Input>
                      </Col>
                      <Col lg={2}>
                        <p className="mb-1 font-size-13">Tipo de pago:</p>
                        <Input
                          type="select"
                          className="form-select"
                          name="payment_type"
                          value={payment_type}
                          onChange={onChange4}
                        >
                          <option value="" defaultValue>
                            Todos
                          </option>
                          <option value="2">Consignación corresponsal bancario</option>
                          <option value="3">Transferencia cta Sucursal Virtual</option>
                          <option value="4">Transferencia Nequi</option>
                          <option value="5">Transferencia Banca Móvil</option>
                        </Input>
                      </Col>
                      <Col lg={3} className="search-box mt-4">
                        <InputGroup>
                          <Input
                            type="text"
                            className="form-control"
                            name="search"
                            id="search"
                            value={search}
                            onChange={onChange1}
                            placeholder="Código cliente..."
                          />
                          <i className="bx bx-search-alt search-icon" />
                          <Button color="primary" onClick={resetFilter}>
                            <span className=" bx bx-x fa-lg align-middle"></span>
                          </Button>
                        </InputGroup>
                      </Col>
                      <Col lg={2} className="mt-4">
                        <Button color="primary" type="submit">
                          Consultar
                        </Button>
                        {consignments.length > 0 && (
                          <Button
                            className="ms-2"
                            color="success"
                            type="button"
                            onClick={onClick}
                          >
                            Exportar
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </Form>
                  <Row className="justify-content-md-center mt-2 mb-2">
                    <Col lg={12}>
                      <hr />
                    </Col>
                  </Row>
                  {consignments.length > 0 ? (
                    <>
                      <Table
                        className="table table-striped table-borderless align-middle table-centered table-nowrap mb-4"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th>Código cliente</th>
                            <th>Nombre cliente</th>
                            <th>Fecha ingreso</th>
                            <th>Método de pago</th>
                            <th>Banco</th>
                            <th>Tipo</th>
                            <th>Fecha consignación</th>
                            <th>Valor</th>
                          </tr>
                        </thead>
                        <tbody>
                          {consignments.map((consignment, idx) => (
                            <tr key={idx}>
                              <th scope="row">{consignment.client}</th>
                              <td>{consignment.full_name}</td>
                              <td>{consignment.created_date}</td>
                              <td>{consignment.payment_method}</td>
                              <td>{consignment.bank}</td>
                              <td>
                                { consignment.payment_type === 1 && "-" }
                                { consignment.payment_type === 2 && "Corresponsal bancario" }
                                { consignment.payment_type === 3 && "Cta Sucursal Virtual" }
                                { consignment.payment_type === 4 && "Nequi" }
                                { consignment.payment_type === 5 && "Banca Móvil" }
                              </td>
                              <td>
                                { consignment.payment_date === "2000-01-01" ? (
                                  "-"
                                ) : (
                                  consignment.payment_date
                                )}
                              </td>
                              <td>
                                $ {consignment.value.toLocaleString("es-CO")}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <Row className="justify-content-md-start">
                        <Col lg={3}>
                          <label>
                            <b>Total ingresos:</b> ${" "}
                            {total.toLocaleString("es-CO")}
                          </label>
                        </Col>
                        <Col lg={3}>
                          <label>
                            <b>Recaudo efectivo:</b> ${" "}
                            {cash.toLocaleString("es-CO")}
                          </label>
                        </Col>
                        <Col lg={3}>
                          <label>
                            <b>Recaudo banco:</b> ${" "}
                            {bank.toLocaleString("es-CO")}
                          </label>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <h3 className="card-title mb-4">
                        No se encontraron resultados
                      </h3>
                      <Row className="justify-content-md-start">
                        <Col lg={3}>
                          <label>
                            <b>Total ingresos:</b> ${" "}
                            {total.toLocaleString("es-CO")}
                          </label>
                        </Col>
                        <Col lg={3}>
                          <label>
                            <b>Recaudo efectivo:</b> ${" "}
                            {cash.toLocaleString("es-CO")}
                          </label>
                        </Col>
                        <Col lg={3}>
                          <label>
                            <b>Recaudo banco:</b> ${" "}
                            {bank.toLocaleString("es-CO")}
                          </label>
                        </Col>
                      </Row>
                    </>
                  )}
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Income;
